function isTouchDevice () {
  return 'ontouchstart' in window || navigator.maxTouchPoints
}

export default isTouchDevice



// WEBPACK FOOTER //
// ./src/utils/isTouchDevice.js